import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import ImageChecker from './ImageChecker';
import RunningText from './RunningText';
import { getCategoryById, getLocationPoi } from '../utils/functions';

const SearchPoiCard = observer(({ poi, onClick }) => {
    const { mapStore, mainStore } = useStores();

    return (
        <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={onClick}
        >
            <ImageChecker
                src={`poi/${poi.logo}`}
                className="w-16 h-16 md:w-[120px] md:h-[120px] object-cover border-[1px] border-[#232323]"
                isCard
            />
            <div className="flex-1 overflow-hidden">
                {/* Poi's Name */}
                {poi.name?.length > 0 && (
                    <RunningText
                        text={poi.name}
                        className="text-[#1C1C1C] text-[10px] sm:text-[12px] md:text-[14px] font-semibold mb-1 truncate"
                    />
                )}

                {/* Category*/}
                {poi.categoryId &&
                    poi.categoryId !== mainStore.config.officeId && (
                        <p className="uppercase text-[#949494] text-[8px] sm:text-[10px] md:text-[12px] font-regular tracking-[.24em] truncate">
                            {
                                getCategoryById(
                                    mapStore.categoryPois,
                                    poi.categoryId
                                )?.name
                            }
                        </p>
                    )}

                {/* Location */}
                <p className="mt-4 text-[8px] sm:text-[10px] md:text-[12px] font-regular break-words text-[#FF6200]">
                    {`${getLocationPoi(mapStore, poi)}`}
                </p>
            </div>
        </div>
    );
});

export default SearchPoiCard;
